<template>
    <div style="display: grid;">
        <div style="grid-column: 1;grid-row: 1">Displaying Results</div>
        <!-- <div class=""> -->
        <div class="polls-g-dr" style="margin-top: 50px">
            <div v-for="(poll, index) in mcqQuestions" :key="poll.id || index">
  <div>
    {{ index + 1 }} {{ poll.questionBank.question }}
  </div>

  <!-- <div
    v-for="(poll_option, ind) in poll.questionBank.options"
    :key="poll_option.id || ind"
    class="answers progress-bar2"
    :class="'progress-bar-' + parseInt(poll_option.option_percent)"
  > -->
  <div
  v-for="(poll_option, ind) in poll.questionBank.options"
  :key="poll_option.id || ind"
  :class="[
    'answers',
    'progress-bar2',
    'progress-bar-' + parseInt(poll_option.option_percent)
  ]"
>

    <div style="padding: 5px;">
      {{ poll_option.value }}
    </div>
    <div>
      {{ parseInt(poll_option.option_percent) }}%
    </div>
  </div>

  <hr>
</div>


        </div>
        <!-- </div> -->
    </div>
</template>
<script>
import axios from 'axios';
export default {
    props : ['event','cme_id'],
    data() {
        return {
          cme: {},
            polls: ['Where did you first hear about us?'],
            pollOptions: ['Hello', 'Hoi', 'Bye', 'Lets Go'],
        }
    },
    mounted() {
        this.getCme();
        console.log("cme",this.cme);
        
    },
    computed: {
        // mcqQuestions() {
        //     return this.cme.question_mapped.filter(
        //         poll => poll.questionBank.question_type === 'mcq'
        //     );
        // }
//         mcqQuestions() {
//     if (
//       !this.cme ||
//       !Array.isArray(this.cme.question_mapped)
//     ) {
//       return [];
//     }

//     return this.cme.question_mapped.filter(
//       q => q?.questionBank?.question_type === "mcq"
//     );
//   }
mcqQuestions() {
    if (!Array.isArray(this.cme?.question_mapped)) {
      return [];
    }

    return this.cme.question_mapped
      .filter(q => q?.questionBank?.question_type === "mcq")
      .map(q => ({
        ...q,
        questionBank: {
          ...q.questionBank,
          options: Array.isArray(q.questionBank.options)
            ? q.questionBank.options
            : []
        }
      }));
  }
// mcqQuestions() {
//         const mapped = this.cme?.question_mapped;

//         if (!Array.isArray(mapped)) {
//             return [];
//         }

//         return mapped
//             .filter(q => q?.questionBank?.question_type === 'mcq')
//             .map(q => ({
//                 ...q,
//                 questionBank: {
//                     ...q.questionBank,
//                     options: Array.isArray(q.questionBank?.options)
//                         ? q.questionBank.options
//                         : []
//                 }
//             }));
//     }
    },

    methods : {
        async getCme(){
            await axios.get(this.event.cme_url+'?cme_id='+this.cme_id)
                .then(res => {
                    console.log(res.data.response);
                    if(res.data.status){
                        this.cme = res.data.response;
                    }
                });
        }
    }
}
</script>
<style scoped>
.polls-g-dr {
    display: grid;
    align-self: center;
    justify-self: center;
    width: 350px;
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    gap: 15px;
}
.polls-g-dr .answers {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 2px;
    border-style: dashed;
    border-color: rgb(11, 183, 131);
    border-image: initial;
    border-radius: 8px;
    margin-bottom:15px;
}
.progress-bar2 {
    position: relative;
    border-radius: 8px;
}
.progress-bar-100 {
    width: 100%;
}
.progress-bar2::before {
    position: absolute;
    height: 33px;
    content: "";
    width: 0px;
    border-radius: 8px;
    background: linear-gradient(rgba(215, 249, 239, 0.4) 100%, rgba(245, 248, 250, 0) 100%);
    transition: width 0.2s;
}
</style>
